// removed by extract-text-webpack-plugin
module.exports = {"container":"_1LoOM"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-dropdown-button.scss
// module id = 708
// module chunks = 3 4 5 6 7